import axios from "axios";
import { useSelector, useDispatch } from 'react-redux';

export function fetchCurrency() {
	return async function(dispatch, getState) {
		try {
            let accountid = getState().auth.user.accountid 
            console.log("===============fetchCurrency=====================");
            console.log( {accountid} );
            console.log("====================================");
            const currency = await axios.post("/auth/account/currency", {accountid });

				console.log("===============fetchCurrency=====================");
				console.log( {currency} );
				console.log("====================================");

				dispatch({ type: "SET_USER_CURRENCY", payload: currency.data.currency });
				return currency;
		} catch (err) {
			console.log("[ERROR] login action ", err);
			return err;
		}
	};
}

